class partyTypeCtrl {
  $onInit() {
    this.chosenTrust = this.trustTypes[this.partyType - 1];
    this.onTypeChange();
  }
}

export default partyTypeCtrl;
